// extracted by mini-css-extract-plugin
export default {"container":"CaptureToobar_container__RisAo","col":"CaptureToobar_col__jfoOS","tabContent":"CaptureToobar_tabContent__zvqaB"};